(() => {
  class CardColorSwatches {
    constructor(element) {
      this.element = element;
      this.element.dataset.cardColorSwatchesInitialized = 'true';
      this.card = this.element.closest('.card-wrapper');
      this.primaryImage = this.card?.querySelector('.card__media .media > img:first-of-type');
      this.swatches = Array.from(this.element.querySelectorAll('[data-card-color-swatch]'));
      this.lastPointerType = '';

      if (this.primaryImage) {
        this.originalImage = {
          src: this.primaryImage.getAttribute('src'),
          srcset: this.primaryImage.getAttribute('srcset'),
          alt: this.primaryImage.getAttribute('alt'),
        };
      }

      this.swatches.forEach((swatch) => {
        swatch.addEventListener('pointerdown', (event) => {
          this.lastPointerType = event.pointerType;
        });
        swatch.addEventListener('pointerenter', (event) => {
          if (event.pointerType === 'mouse' && !this.hasCoarsePointer()) this.preview(swatch);
        });
        swatch.addEventListener('focus', () => {
          if (this.lastPointerType !== 'touch' && this.lastPointerType !== 'pen' && !this.hasCoarsePointer()) {
            this.preview(swatch);
          }
        });
        swatch.addEventListener('click', (event) => this.handleClick(event, swatch));
      });

      this.element.addEventListener('pointerleave', (event) => {
        if (event.pointerType === 'mouse') this.restore();
      });
      this.element.addEventListener('focusout', (event) => {
        if (!this.element.contains(event.relatedTarget)) this.restore();
      });
    }

    handleClick(event, swatch) {
      event.stopPropagation();

      const isKeyboardClick = event.detail === 0;
      const isCoarsePointer =
        this.lastPointerType === 'touch' || this.lastPointerType === 'pen' || this.hasCoarsePointer();

      if (!isKeyboardClick && isCoarsePointer && !swatch.classList.contains('is-selected')) {
        event.preventDefault();
        this.preview(swatch);
      }
    }

    hasCoarsePointer() {
      return window.matchMedia('(hover: none), (pointer: coarse)').matches;
    }

    preview(swatch) {
      this.setSelected(swatch);

      if (!this.primaryImage || !swatch.dataset.previewSrc) return;

      this.primaryImage.setAttribute('src', swatch.dataset.previewSrc);
      if (swatch.dataset.previewSrcset) {
        this.primaryImage.setAttribute('srcset', swatch.dataset.previewSrcset);
      } else {
        this.primaryImage.removeAttribute('srcset');
      }
      if (swatch.dataset.previewAlt) this.primaryImage.setAttribute('alt', swatch.dataset.previewAlt);
      this.card?.classList.add('is-color-previewing');
    }

    restore() {
      this.setSelected(null);
      if (!this.primaryImage || !this.originalImage) return;

      this.restoreAttribute('src', this.originalImage.src);
      this.restoreAttribute('srcset', this.originalImage.srcset);
      this.restoreAttribute('alt', this.originalImage.alt);
      this.card?.classList.remove('is-color-previewing');
    }

    restoreAttribute(name, value) {
      if (value == null) {
        this.primaryImage.removeAttribute(name);
      } else {
        this.primaryImage.setAttribute(name, value);
      }
    }

    setSelected(selectedSwatch) {
      this.swatches.forEach((swatch) => {
        const isSelected = swatch === selectedSwatch;
        swatch.classList.toggle('is-selected', isSelected);
        if (isSelected) {
          swatch.setAttribute('aria-current', 'true');
        } else {
          swatch.removeAttribute('aria-current');
        }
      });
    }
  }

  const initializeSwatches = (root = document) => {
    root.querySelectorAll?.('[data-card-color-swatches]:not([data-card-color-swatches-initialized])').forEach((element) => {
      new CardColorSwatches(element);
    });
  };

  initializeSwatches();

  const mainContent = document.getElementById('MainContent');
  if (mainContent) {
    new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE) initializeSwatches(node);
        });
      });
    }).observe(mainContent, { childList: true, subtree: true });
  }
})();
